import React, { useState, useContext } from "react";
import "../styles/MobileLogin.css";
import Advert from "./Advert";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import api from "../context/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function PasswordResetStep1() {
  const { phoneNumber, setPhoneNumber } = useContext(AuthContext);
  const navigate = useNavigate();
  const [countryCode, setCountryCode] = useState("233");
  const [isLoading, setIsLoading] = useState(false);

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handleSendOTP = async () => {
    if (!phoneNumber) {
      toast.error("Please enter a valid mobile number.");
      return;
    }

    setIsLoading(true);

    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "GH");

    if (!phoneNumberObj || !phoneNumberObj.isValid()) {
      toast.error("Invalid Phone Number. Please enter a valid phone number.");
      setIsLoading(false);
      return;
    }

    const formattedPhoneNumber = phoneNumberObj.format("E.164");

    try {
      // Check if user exists
      const checkUserResponse = await api.post("/Reset", {
        phoneNumber: formattedPhoneNumber,
      });

      if (checkUserResponse.data === "exist") {
        // Send OTP
        const response = await api.post("/otp/send", {
          senderId: "Huntex",
          phoneNumber: formattedPhoneNumber,
          countryCode: "GH",
        });

        const data = response.data;

        if (data.code === "0000" && data.data) {
          navigate("/reset-password-verify", {
            state: {
              prefix: data.data.prefix,
              requestId: data.data.requestId,
              phoneNumber: formattedPhoneNumber,
            },
          });
        } else {
          toast.error("Failed to send OTP: " + (data.message || "Unknown error"));
        }
      } else if (checkUserResponse.data === "notexist") {
        toast.error("You don't have an account with us. Please sign up.");
      } else {
        toast.error("Unexpected response from server. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while sending OTP. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <div className="login-image-top"></div>
      <div className="login-box">
        <h1>Reset Your Password</h1>
        <p>Enter your phone number to receive a verification code</p>

        <form onSubmit={(e) => { e.preventDefault(); handleSendOTP(); }}>
          {/* Country Code + Phone Input */}
          <div className="input-group">
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
            >
              <option value="233">🇬🇭 +233</option>
              <option value="234">🇳🇬 +234</option>
              <option value="1">🇺🇸 +1</option>
              <option value="44">🇬🇧 +44</option>
            </select>
            <input
              type="tel"
              placeholder="Mobile Number (eg 054 099 0099)"
              value={phoneNumber}
              onChange={(e) => handlePhoneNumberChange(e.target.value)}
              required
            />
          </div>

          {/* Submit */}
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Send Reset Code"}
          </button>
        </form>

        {/* Links */}
        <div className="links">
          <span>
            Remember your password? <a href="#" onClick={() => navigate('/login')}>Login</a>
          </span>
          <span>
            New to Huntex? <a href="#" onClick={() => navigate("/MobileLogin")}>Sign Up</a>
          </span>
        </div>

        <p className="support-text">
          Having a problem? <a href="#">Contact support</a>
        </p>
      </div>
      <div style={{ marginTop: "90px", width: "100%" }}>
        <Advert />
      </div>
    </div>
  );
}
